import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Match } from '@reach/router';
import { Link } from '@cowsquare/design';
import { themeGet } from '@styled-system/theme-get';
import { StripeProvider } from 'react-stripe-elements';
import { STRIPE_CLIENT_KEY } from '../../constants/index';
import Header from './header/Header';
import FAVICON_ICO from '../../asset/favicon.ico';
import FAVICON_PNG_16 from '../../asset/favicon-16x16.png';
import FAVICON_PNG_32 from '../../asset/favicon-32x32.png';
import FAVICON_SVG from '../../asset/favicon.svg';

const FootLink = styled(Link)`
  display: inline;
  font-size: 14px;
`;

const Footer = styled.footer`
  width: 100%;
  padding: 16px 28px;
  font-size: 14px;
  color: ${themeGet('colors.blacks.4')};
  background-color: ${themeGet('colors.blacks.9')};
  text-align: center;
`;

const Container = styled.main`
  min-height: 100vh;
  background-color: #f4f5f8;
`;

const Content = styled.div`
  max-width: 1440px;
  /* 120px = header height(60px) + footer height(60px) */
  min-height: calc(100vh - 120px);
  margin: 0 auto;
`;

const Layout = ({ children }) => {
  const [stripe, setStripe] = useState(null);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.stripe.com/v3/';
    script.async = true;
    script.addEventListener('load', () => {
      setStripe(window.Stripe(STRIPE_CLIENT_KEY));
    });
    document.body.appendChild(script);
  }, []);
  return (
    <StripeProvider stripe={stripe}>
      <Container>
        <Helmet>
          <link rel="shortcut icon" href={FAVICON_ICO} />
          <link rel="icon" type="image/png" sizes="16x16" href={FAVICON_PNG_16} />
          <link rel="icon" type="image/png" sizes="32x32" href={FAVICON_PNG_32} />
          <link rel="mask-icon" href={FAVICON_SVG} color="#4560b0" />
        </Helmet>
        <Match path="/:role/*">{props => <Header role={R.path(['match', 'role'], props)} />}</Match>
        <Content>{children}</Content>
        <Footer>
          Copyright © 2019 Hong Kong Doctors Union. All rights reserved. Powered by&nbsp;
          <FootLink href="https://www.cowsquare.com/">CowSquare</FootLink>
        </Footer>
      </Container>
    </StripeProvider>
  );
};

export default Layout;
